import {EstabelecimentoModel} from '../estabelecimento.model';
import {
    RascunhoIdentificacaoPrincipalModel,
    RascIdentificacaoPrincipalModel
} from './composicao/rasc-identificacao-principal-model';
import {RascEntidadeAdministrativaModel} from './composicao/rasc-entidade-administrativa.model';
import {RascAtividadesModel} from './composicao/rasc-atividades.model';
import {
    ClassificacaoServico,
    RascServicosEspecializadoModel,
    ServicoEspecializado
} from './composicao/rasc-servicos-especializado.model';
import {NivelAtencao, RascNivelAtencaoModel} from './composicao/rasc-nivel-atencao.model';
import {RascHorarioAtendimentoModel} from './composicao/rasc-horario-atendimento.model';
import {AtendimentoObj, ConvenioObj, RascConvenioModel} from './composicao/rasc-convenio.model';
import {LeitoObj, RascLeitoModel} from './composicao/rasc-leito.model';
import {EquipamentoObj, RascEquipamentoModel, RascunhoEquipamentoModel} from './composicao/rasc-equipamento.model';
import {InstalacaoObj, RascInstalacaoModel} from './composicao/rasc-instalacao.model';
import {ConselhoClasse, ProfissionalObj, RascProfissionalModel} from './composicao/rasc-profissional.model';
import {EnderecoComplementarModel} from '../../../pages/gestor/models/identificacao/endereco-complementar.model';
import {IRascProfissionalEquipe, RascEquipeModel} from './composicao/rasc-equipe.model';
import {RascDadosIndigenasModel} from './composicao/rasc-dados-indigenas.model';
import * as moment from 'moment';
import {RascEnderecoComplementarModel} from './composicao/rasc-endereco-complementar.model';
import {Guid} from 'guid-typescript';
import {IProfissionalEquipe} from '../recursos-humanos/estab-equipe.model';
import {EstabSevicoModel} from '../caracterizacao/estab-sevico.model';
import {
    EstabEnderecoComplementarModel,
    IEstabEnderecoComplementar
} from '../identificacao/estab-endereco-complementar.model';
import {RascIdentificacaoComplementarModel} from './composicao/rasc-identificacao-complementar-model';
import {RascIdentificacaoEnderecoComplementarModel} from './composicao/rasc-identificacao-endereco-complementar-model';

export class RascunhoModel {
    estabelecimentoPrincipal: RascIdentificacaoPrincipalModel;
    estabelecimentoIdentificacaoPrincipal: RascunhoIdentificacaoPrincipalModel;
    estabelecimentoIdentificacaoComplementar: RascIdentificacaoComplementarModel;
    estabelecimentoIdentificacaoEnderecoComplementar: RascIdentificacaoEnderecoComplementarModel;
    dadosIndigenas: RascDadosIndigenasModel;
    entidadesAdministrativas: RascEntidadeAdministrativaModel[];
    atividades: RascAtividadesModel;
    servicosEspecializados: RascServicosEspecializadoModel[];
    niveisAtencao: RascNivelAtencaoModel[];
    horarioAtendimento: RascHorarioAtendimentoModel[];
    convenios: RascConvenioModel[];
    leitos: RascLeitoModel[];
    // equipamentos: RascEquipamentoModel[];
    equipamentos: RascunhoEquipamentoModel[];
    instalacoes: RascInstalacaoModel[];
    profissionais: RascProfissionalModel[];
    enderecosComplementares: RascEnderecoComplementarModel[]; // Verificar no json
    equipes: RascEquipeModel[];

    constructor(estabelecimento: EstabelecimentoModel) {
        // console.log('RascunhoModel: ', estabelecimento);
        this.estabelecimentoPrincipal = new RascIdentificacaoPrincipalModel(estabelecimento); // OK
        this.estabelecimentoIdentificacaoPrincipal = new RascunhoIdentificacaoPrincipalModel(estabelecimento); // OK
        this.estabelecimentoIdentificacaoComplementar = new RascIdentificacaoComplementarModel(estabelecimento);
        this.estabelecimentoIdentificacaoEnderecoComplementar = new RascIdentificacaoEnderecoComplementarModel(estabelecimento);
        this.dadosIndigenas = new RascDadosIndigenasModel(estabelecimento); // OK
        this.entidadesAdministrativas = this.montarEntidadesAdministrativas(estabelecimento);
        this.atividades = new RascAtividadesModel(estabelecimento);
        this.servicosEspecializados = this.montarServicosEspecializados(estabelecimento);
        this.niveisAtencao = this.montarNiveisAtencao(estabelecimento);
        this.horarioAtendimento = this.montarHorarioAtendimento(estabelecimento);
        this.convenios = this.montarConvenios(estabelecimento);
        this.leitos = this.montarLeitos(estabelecimento);
        this.equipamentos = this.montarEquipamentosPost(estabelecimento);
        this.instalacoes = this.montarInstalacoes(estabelecimento);
        this.profissionais = this.montarProfissionais(estabelecimento);
        this.enderecosComplementares = null;
        // this.montarEnderecosComplementares(estabelecimento);
        this.equipes = this.montarEquipes(estabelecimento);
    }

    private montarEntidadesAdministrativas(estabelecimento: EstabelecimentoModel): RascEntidadeAdministrativaModel[] {
        const lista: RascEntidadeAdministrativaModel[] = [];

        // TODO Gerar uma lista de entidades baseadas na Mantenedora e Adm Terceiro quando tiver

        // estabelecimento.identificacao.complementar.cnpjAdministradorTerceiro;
        // estabelecimento.identificacao.complementar.nomeEmpresarialAdministradorTerceiro;
        // estabelecimento.identificacao.complementar.naturezaJuridicaAdministradorTerceiro;

        /*this.nomeMantenedora = estabelecimento.identificacao.principal.nomeEmpresarialMantenedora;
        if (estabelecimento.identificacao.principal.naturezaJuridicaMantenedora.includes('-')) {
            const natureza = estabelecimento.identificacao.principal.naturezaJuridicaMantenedora.split('-');
            this.naturezaJuridicaMantenedora = natureza[0];
            this.naturezaJuridicaMantenedoraDescricao = natureza[1];
        } else {
            this.naturezaJuridicaMantenedora = '';
            this.naturezaJuridicaMantenedoraDescricao = '';
        }
        this.cnpjMantenedora = estabelecimento.identificacao.principal.cnpjMantenedora;*/


        if (lista.length > 0) {
            return lista;
        } else {
            return null;
        }
    }

    private montarServicosEspecializados(estabelecimento: EstabelecimentoModel): RascServicosEspecializadoModel[] {
        const lista: RascServicosEspecializadoModel[] = [];
        estabelecimento.caracterizacao.servicos.forEach((item) => {
            lista.push({
                cnes: estabelecimento.cnes,
                estabelecimento: estabelecimento.codigoUnidade,
                tipoCaracteristica: '',
                dataAtualizacao: moment().format('DD/MM/YYYY'),
                dataInicioCompetencia: '',
                dataFimCompetencia: '',
                atendeSUS: item.atendeSUS,
                ativo: '',
                servicoEspecializado: {
                    id: item.id,
                    codigo: item.idServico,
                    descricao: item.servico,
                    dataAtualizacao: moment().format('DD/MM/YYYY'),
                    movimentacao: '',
                    dataInicioCompetencia: '',
                    dataFimCompetencia: '',
                    ativo: '',
                    dataInativacao: '',
                },
                classificacaoServico: {
                    id: item.id,
                    codigo: item.idClassificacao,
                    descricao: item.classificacao,
                    codigoServicoEspecializado: item.idServico,
                    dataAtualizacao: moment().format('DD/MM/YYYY'),
                    numeroCompetencia: '',
                },
                enderecosComplementares: this.montarEnderecoComplementarEquipe(estabelecimento.codigoUnidade, item.enderecosComplementares),
                codigoPrestador: item.idPrestador,
                descricaoPrestador: item.prestador,
            });
        });
        if (lista.length > 0) {
            return lista;
        } else {
            return null;
        }
    }

    private montarNiveisAtencao(estabelecimento: EstabelecimentoModel): RascNivelAtencaoModel[] {
        const lista: RascNivelAtencaoModel[] = [];
        estabelecimento.caracterizacao.geral.niveisAtencao.forEach((item) => {
            lista.push({
                estabelecimento: estabelecimento.codigoUnidade,
                nivelAtencao: item.idComplexidade,
                descricaoNivelAtencao: item.descricaoComplexidade,
                gestao: item.idGestao,
                descricaoGestao: item.descricaoGestao,
                idTipo: item.idTipo,
                descricaoTipo: item.descricaoTipo,
                dataAtualizacao: moment().format('DD/MM/YYYY'),
                secProcesso: '',
                dataAtualizacaoOrigem: moment().format('DD/MM/YYYY'),
                dataCompetenciaInicio: '',
                dataCompetenciaFim: '',
                nivelAtencaoObj: {
                    id: item.id,
                    codigo: item.idComplexidade,
                    descricao: item.descricaoComplexidade,
                    tipoPrograma: item.idTipo,
                    ativo: '',
                    dataInativacao: '',
                }
            });
        });

        if (lista.length > 0) {
            return lista;
        } else {
            return null;
        }
    }

    private montarHorarioAtendimento(estabelecimento: EstabelecimentoModel): RascHorarioAtendimentoModel[] {
        const lista: RascHorarioAtendimentoModel[] = [];
        if (lista.length > 0) {
            return lista;
        } else {
            return null;
        }
    }

    private montarConvenios(estabelecimento: EstabelecimentoModel): RascConvenioModel[] {
        const lista: RascConvenioModel[] = [];

        estabelecimento.caracterizacao.geral.convenios.forEach((item) => {
            lista.push({
                atendimentoObj: null,
                convenioObj: {
                    id: item.id,
                    codigo: item.idConvenio,
                    descricao: item.descricaoConvenio,
                    dataAtualizacao: moment().format('DD/MM/YYYY'),
                    ativo: '',
                },
                estabelecimento: estabelecimento.codigoUnidade,
                atendimento: '',
                convenio: item.idConvenio,
                usuario: '',
                dataAtualizacao: moment().format('DD/MM/YYYY'),
                secProcesso: '',
                dataAtualizacaoOrigem: moment().format('DD/MM/YYYY'),
                dataCompetenciaInicio: '',
                dataCompetenciaFim: '',
            });
        });
        if (lista.length > 0) {
            return lista;
        } else {
            return null;
        }
    }

    private montarLeitos(estabelecimento: EstabelecimentoModel): RascLeitoModel[] {
        const lista: RascLeitoModel[] = [];
        estabelecimento.recursoFisico.leitos.forEach((item) => {
            lista.push({
                estabelecimento: estabelecimento.codigoUnidade,
                leito: {
                    id: item.id,
                    codigo: item.idTipo,
                    descricao: item.tipo,
                    tipoLeito: item.idTipo,
                    codigoDetalhamento: item.codigoLeito,
                    descricaoDetalhamento: item.detalhamento,
                    dataAtualizacao: moment().format('DD/MM/YYYY'),
                },
                tipoLeito: item.idTipo,
                descricaoTipoLeito: item.tipo,
                quantidadeExistente: item.quantidadeAtivo.toString(),
                quantidadeNoSus: item.quantidadeNoSus.toString(),
                quantidadeHabilitados: '',
                competenciaInicial: '',
                competenciaFinal: '',
                dataAtualizacao: moment().format('DD/MM/YYYY'),
            });
        });
        if (lista.length > 0) {
            return lista;
        } else {
            return null;
        }
    }

    private montarEquipamentosPost(estabelecimento: EstabelecimentoModel): RascunhoEquipamentoModel[] {
        // console.log('montarEquipamentosPost: ', estabelecimento);
        const lista: RascunhoEquipamentoModel[] = [];
        estabelecimento.recursoFisico.equipamentos.forEach((item) => {
            lista.push({
                codigoEquipamento: item.idEquipamento,
                quantidade: item.quantidadeExistente
            });
        });
        if (lista.length > 0) {
            return lista;
        } else {
            return null;
        }
    }

    private montarEquipamentos(estabelecimento: EstabelecimentoModel): RascEquipamentoModel[] {
        const lista: RascEquipamentoModel[] = [];
        estabelecimento.recursoFisico.equipamentos.forEach((item) => {
            lista.push({
                equipamento: {
                    codigo: item.idEquipamento,
                    descricao: item.equipamento,
                    tipoEquipamento: {
                        codigo: item.idTipoEquipamento,
                        descricao: item.tipoEquipamento
                    },
                },
                quantidadeExistente: item.quantidadeExistente,
                id: ''
            });
        });
        if (lista.length > 0) {
            return lista;
        } else {
            return null;
        }
    }

    private montarInstalacoes(estabelecimento: EstabelecimentoModel): RascInstalacaoModel[] {
        const lista: RascInstalacaoModel[] = [];
        estabelecimento.recursoFisico.instalacoes.forEach((item) => {
            lista.push({
                estabelecimento: estabelecimento.codigoUnidade,
                instalacao: {
                    id: item.id,
                    codigo: item.idInstalacao,
                    subTipoInstalacao: item.idSubTipo,
                    descricaoSubTipoInstalacao: item.subTipo,
                    descricao: item.instalacao,
                    tipoInstalacao: item.idTipo,
                    descricaoTipoInstalacao: item.tipo,
                    dataAtualizacao: moment().format('DD/MM/YYYY'),
                },
                quantidadeInstalacoes: item.quantidadeInstalacoes.toString(),
                quantidadeLeitos: item.quantidadeLeitos.toString(),
                dataAtualizacao: moment().format('DD/MM/YYYY'),
            });
        });
        if (lista.length > 0) {
            return lista;
        } else {
            return null;
        }
    }

    private montarProfissionais(estabelecimento: EstabelecimentoModel): RascProfissionalModel[] {
        const lista: RascProfissionalModel[] = [];
        estabelecimento.recursoHumano.profissionais.forEach((item) => {
            lista.push({
                estabelecimento: estabelecimento.codigoUnidade,
                profissional: {
                    id: item.id,
                    cpf: item.cpf,
                    nome: item.nome,
                    nomeMae: '',
                    cns: item.cns,
                    dataNascimento: '',
                },
                responsavelAdministrativo: item.responsavelAdministrativo.toString(),
                responsavelTecnico: item.responsavelTecnico.toString(),
                // residenciaMultiprofissional: item.residenciaMultiprofissional.toString(),
                vinculacao: '',
                sus_nao_sus: '',
                residente: item.residente.toString(),
                preceptor: '',
                numeroRegistro: '',
                ufCRM: '',
                conselhoClasse: null,
                cargaHorariaOutro: 0,
                cargaHorariaAmbulatorial: 0,
                cargaHorariaHospitalSus: 0,
                vinculoEmpregador: '',
                vinculoEstabelecimento: '',
                detalhamentoVinculo: '',
                cbosVinculados: item.cbosVinculados
            });
        });
        if (lista.length > 0) {
            return lista;
        } else {
            return null;
        }
    }

    private montarEnderecosComplementares(estabelecimento: EstabelecimentoModel): any {

    }

    private montarServicosEnderecoComplementar(cnes, codigoUnidade, servicos: EstabSevicoModel[]): any {
        /*const lista: RascServicosEspecializadoModel[] = [];
        servicos.forEach((item) => {
            lista.push({
                cnes,
                estabelecimento: codigoUnidade,
                tipoCaracteristica: '',
                dataAtualizacao: moment().format('DD/MM/YYYY'),
                dataInicioCompetencia: '',
                dataFimCompetencia: '',
                atendeSUS: item.atendeSUS,
                ativo: '',
                servicoEspecializado: {
                    id: item.id,
                    codigo: item.idServico,
                    descricao: item.servico,
                    dataAtualizacao: moment().format('DD/MM/YYYY'),
                    movimentacao: '',
                    dataInicioCompetencia: '',
                    dataFimCompetencia: '',
                    ativo: '',
                    dataInativacao: '',
                },
                classificacaoServico: {
                    id: item.id,
                    codigo: item.idClassificacao,
                    descricao: item.classificacao,
                    codigoServicoEspecializado: item.idServico,
                    dataAtualizacao: moment().format('DD/MM/YYYY'),
                    numeroCompetencia: '',
                },
                codigoPrestador: item.idPrestador,
                descricaoPrestador: item.prestador
            });
        });
        if (lista.length > 0) {
            return lista;
        } else {
            return null;
        }*/
    }


    private montarEquipes(estabelecimento: EstabelecimentoModel): RascEquipeModel[] {
        const lista: RascEquipeModel[] = [];
        estabelecimento.recursoHumano.equipes.forEach((item) => {
            lista.push({
                INE: item.ine,
                estabelecimento: estabelecimento.codigoUnidade,
                tipoEquipe: item.idTipoEquipe,
                descricaoTipoEquipe: item.tipoEquipe,
                codigoSubTipoEquipe: item.idSubTipoEquipe,
                subTipoEquipe: item.subTipoEquipe,
                codigoArea: item.idArea,
                area: item.area,
                nomeReferencia: item.nomeReferencia,
                municipio: '',
                sequecialEquipe: '',
                atendeQuilombola: '',
                atendeAssentamentos: '',
                atendePopGeral: '',
                atendeRibeirinha: '',
                dataAtivacao: item.dataAtivacao,
                dataDesativacao: item.dataDesativacao,
                embarcacoes: '',
                aldeia: '',
                // tslint:disable-next-line:max-line-length
                profissionais: this.montarProfissionaisVinculadoEquipe(estabelecimento.codigoUnidade, item.ine, item.profissionaisVinculados),
                unidadesApoio: this.montarEnderecoComplementarEquipe(estabelecimento.codigoUnidade, item.enderecosComplementaresVinculados),
            });
        });
        if (lista.length > 0) {
            return lista;
        } else {
            return null;
        }
    }

    private montarEnderecoComplementarEquipe(codigoUnidade, enderecos: IEstabEnderecoComplementar[]): RascEnderecoComplementarModel[] {
        const lista: RascEnderecoComplementarModel[] = [];
        enderecos.forEach((item) => {
            lista.push({
                bairro: item.bairro,
                cep: item.cep,
                codigo: item.id,
                dataAtivacao: item.dataAtivacao,
                dataDesativacao: item.dataDesativacao,
                dddFax: '',
                dddTelefone: '',
                email: '',
                estabelecimento: codigoUnidade,
                fax: '',
                municipio: item.nomeMunicipio,
                ibgeMunicipio: item.codigoMunicipioIBGE,
                ibgeUf: item.siglaUf,
                identificacao: item.identificacao,
                nomeComplemento: item.complemento,
                nomeLogradouro: item.logradouro,
                numeroEndereco: item.numeroEndereco,
                sequencial: '',
                telefone: item.telefone,
                tipoLogradouro: '',
                usuario: '',
            });
        });
        if (lista.length > 0) {
            return lista;
        } else {
            return null;
        }
    }


    private montarProfissionaisVinculadoEquipe(codigoUnidade, ine, profissionais: IProfissionalEquipe[]): IRascProfissionalEquipe[] {
        const lista: IRascProfissionalEquipe[] = [];
        profissionais.forEach((item) => {
            lista.push({
                equipeIne: ine,
                profissional: {
                    cbo: {
                        id: item.idCbo,
                        descricao: item.cbo,
                        codigoOrgaoEmissor: item.idOrgaoEmissor,
                        orgaoEmissor: item.orgaoEmissor,
                        registroConselhoClasse: item.registroConselhoClasse,
                    },
                    estabelecimento: codigoUnidade,
                    profissional: {
                        id: item.profissional.id,
                        cpf: item.profissional.cpf,
                        nome: item.profissional.nome,
                        nomeMae: '',
                        cns: item.profissional.cns,
                        dataNascimento: '',
                    },
                    responsavelAdministrativo: item.profissional.responsavelAdministrativo,
                    responsavelTecnico: item.profissional.responsavelTecnico,
                    vinculacao: '',
                    sus_nao_sus: '',
                    residente: item.profissional.residente,
                    preceptor: '',
                    numeroRegistro: '',
                    ufCRM: '',
                    conselhoClasse: null,
                    cargaHorariaOutro: '',
                    cargaHorariaAmbulatorial: '',
                    cargaHorariaHospitalSus: '',
                    vinculoEmpregador: '',
                    vinculoEstabelecimento: '',
                    detalhamentoVinculo: '',
                },
                quantidadeHoras: item.quantidadeHoras.toString(),
                dataEntrada: item.dataEntrada,
                dataDesligamento: item.dataDesligamento
            });
        });
        if (lista.length > 0) {
            return lista;
        } else {
            return null;
        }
    }
}
